export default __webpack_public_path__ + "static/media/screenshot.df06007f.webp";